export const BUTTON_TYPE = {
    RETRY: 'RETRY',
    CLOSE: 'CLOSE',
    RELOAD: 'RELOAD',
    GOHOME: 'GOHOME',
    CUSTOM: 'CUSTOM',
    CONNECT: 'CONNECT'
};
